import { CssPropertyType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { GlobalDesignAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';
import { CornerStyleValue, LengthStyleValue } from '../common/lobby/types';
import { MergingStrategyConfig } from '../common/grouping/types';
import defaultValueMergingStrategy from '../common/grouping/defaultValueMergingStrategy';
import { CornerStyleValueService } from './cornersStyleValueService';

export const cornerGrouping: GlobalDesignAction<'cornerStyles'>['grouping'] = {
  getGroupingStrategy: (editorPointer, getHost) => {
    return () => {
      return groupByGroupDefinitions(editorPointer, 'cornerStyles', getHost);
    };
  },

  applyValueMergingStrategy: (stylesGroups) => {
    const compareBorderRadius = (
      value1: CornerStyleValue | LengthStyleValue,
      value2: CornerStyleValue | LengthStyleValue,
    ) => {
      if (!value1 || !value2) {
        return false;
      }

      const valueService = new CornerStyleValueService();
      return valueService.isEqual([value1, value2]);
    };

    const config: MergingStrategyConfig<'cornerStyles'> = {
      valueComparator: {
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderTopLeftRadius]: compareBorderRadius,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderTopRightRadius]: compareBorderRadius,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderBottomRightRadius]: compareBorderRadius,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderBottomLeftRadius]: compareBorderRadius,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.borderRadius]: compareBorderRadius,
      },
      allowSubsets: false,
    };

    return defaultValueMergingStrategy<'cornerStyles'>(stylesGroups, config);
  },
};
